/*
 * @Description: 总入口
 * @Autor: Popper_Li
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Env from '@Env'
import Directives from '@/directives'
import Components from '@c'
import '@/assets/scss/common/_reset.scss'
import 'lib-flexible'

import Vant from 'vant';
import { Lazyload, ImagePreview, Toast, Form, Field } from 'vant';
Vue.use(Lazyload);
Vue.use(ImagePreview);
Vue.use(Toast);
Vue.use(Form);
Vue.use(Field);
import 'vant/lib/index.css';
import vueWechatTitle from 'vue-wechat-title'
import VueAMap from 'vue-amap';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'//这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VueVideoPlayer);
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(VueAMap);

Vue.use(vueWechatTitle)
Vue.use(Vant);


Vue.config.productionTip = false

// 自动注册组件
Vue.use(Components)
// 自动注册指令
Vue.use(Directives)

/* eslint-disable no-new */
if (Env.openVconsole) {
  const VConsole = require('vconsole')
  // new VConsole()
}
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
